import React from "react"; 
import { Link } from "react-router-dom";    
import DealerQuotationsList from "./view";

const DealerQuotations = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
         <h5>Quotations List</h5>
        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Quotations List</li>
        </ul>
      </div> */}

      <DealerQuotationsList />
    </>
  );
};

export default DealerQuotations;

export { default as DealerQuotationForm } from './DealerQuotationForm';